var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showDetails)?_c('participant-details-card',{attrs:{"files":_vm.files},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }